import { render } from "./ClaimEventDropdown.vue?vue&type=template&id=c5a7f4a2"
import script from "./ClaimEventDropdown.vue?vue&type=script&lang=js"
export * from "./ClaimEventDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__